export function berthToDrawing(berth, chainageM, signedOffsetM) {
  const scale = Number(berth?.scale_m_per_px);
  if (!Number.isFinite(scale) || scale <= 0) return null;
  const angle = (Number(berth?.orientation_deg) || 0) * Math.PI / 180;
  const along = Number(chainageM) / scale;
  const offset = Number(signedOffsetM) / scale;
  if (![along, offset].every(Number.isFinite)) return null;
  return {
    x: Number(berth.x1 || 0) + along * Math.cos(angle) - offset * Math.sin(angle),
    y: Number(berth.y1 || 0) + along * Math.sin(angle) + offset * Math.cos(angle),
  };
}

export function drawingToBerth(berth, x, y) {
  const scale = Number(berth?.scale_m_per_px);
  if (!Number.isFinite(scale) || scale <= 0) return null;
  const angle = (Number(berth?.orientation_deg) || 0) * Math.PI / 180;
  const dx = Number(x) - Number(berth?.x1 || 0);
  const dy = Number(y) - Number(berth?.y1 || 0);
  if (![dx, dy].every(Number.isFinite)) return null;
  return {
    chainage: (dx * Math.cos(angle) + dy * Math.sin(angle)) * scale,
    offset: (-dx * Math.sin(angle) + dy * Math.cos(angle)) * scale,
  };
}
